export const en = {
    "action-cancel-review": "Return to development",
    "action-deploy": "Deploy",
    "action-request-review": "Request review",
    "action-request-review-again": "Send again",
    "aired-deploy": "The new version of the dialog has been sent for publication.",
    "back": "Back",
    "button-change-date": "Change the date or parameters",
    "cancel": "Cancel",
    "checklist-full": "Complete list of requirements",
    "checklist-hidden-rules": "activation names are word forms (declensions) of the skill name and do not consist of common phrases\nskill name and each activation name is no shorter than 2 words (except for branded ones) and no longer than 4 words",
    "checklist-public-rules": "activation names are word forms (declensions) of the skill name and do not consist of common phrases\nskill name and each activation name is no shorter than 2 words (except for branded ones) and no longer than 4 words\nthe description contains information about the skill and interaction with it\nthe welcome message contains a brief instruction on how to interact with the skill\nskill answers the commands \"Help\" and \"What can you do?\" with instructions\nthe skill's current functionality matches the description\nthe server does not respond with an error",
    "checklist-sh-texts-yandex": "The account can be linked to Yandex without any problems, and all devices connected in your application appear in the Yandex application\nAll the <a target=\"_blank\" href=\"https://yandex.ru/dev/dialogs/alice/doc/smart-home/concepts/capability-types.html/\">capabilities</a> provided work on each device: any action in the interface is performed quickly and without errors\nAll the devices should be accessible in the UI without any error despite being offline/online or any other status\nYou can create working scenarios with one or more devices declared in the skill",
    "checklist-sh-texts-yango": "The account can be linked to Yango without any problems, and all devices connected in your application appear in the Yango application\nAll the <a target=\"_blank\" href=\"https://dialogs.yango.com/docs/smart-home/doc/concepts/capability-types.html/\">capabilities</a> provided work on each device: any action in the interface is performed quickly and without errors\nAll the devices should be accessible in the UI without any error despite being offline/online or any other status\nYou can create working scenarios with one or more devices declared in the skill",
    "comment": "Comment",
    "continue": "Continue",
    "date-time": "Date and time",
    "desc-approved": "The moderator has approved your dialogue for publication. After clicking on the button below, it will become available to users.",
    "desc-deploy": "The dialog has been sent for publication.",
    "desc-in-dev": "You can change its settings.",
    "desc-in-review": "The dialog will be reviewed by the moderator within three days.",
    "eng": "English",
    "error": "Error occured",
    "error-try-again": "The operation could not be performed. Try again.",
    "errors-validation": "Validation errors:",
    "invalid-settings": "The settings are filled in incorrectly.\nFill in the required dialog settings and account linking.",
    "lang": "Language",
    "make-sure": "Make sure, that",
    "meeting-approved": "Agreed",
    "meeting-approved-on": "Agreed on",
    "meeting-choose-lang": "What is your preferred language?",
    "meeting-devices-sent-yandex": "All devices stated in the description have been transferred to the Yandex office, and testing via Skype is not required.",
    "meeting-devices-sent-yango": "All devices stated in the description have been transferred to the Yango office, and testing via Skype is not required.",
    "meeting-not-agreed": "Not agreed. Change the date",
    "meeting-office": "In office",
    "meeting-prepare-yandex": "Prepare a test bench with all types of devices stated in the skill description. The devices must be real and Yandex representatives must be able to manage them through the Yandex.",
    "meeting-prepare-yango": "Prepare a test bench with all types of devices stated in the skill description. The devices must be real and Yango representatives must be able to manage them through the Yango.",
    "meeting-provider-login": "Login from the provider's application",
    "meeting-provider-password": "Password from the provider's application",
    "meeting-zoom": "Zoom",
    "meeting-zoom-link": "Zoom link",
    "meeting-skype": "Skype",
    "meeting-skype-login": "Skype login",
    "meeting-wait-approval": "Waiting approval",
    "others": "Прочее",
    "published": "published",
    "rus": "Russian",
    "save": "Save",
    "sh-desc-approved": "Your skill can now be published. Do this and it will be available to users.",
    "sh-desc-devices-testing": "Checking if your skill is working well.",
    "sh-desc-in-dev": "This is a draft and its settings can be changed.",
    "sh-desc-in-review": "Validating the description of the skill with the formal requirements.",
    "sh-desc-meeting": "We wrote you a letter and are waiting for you to select a date for testing the devices.",
    "sh-desc-testing-complete": "We will send you a report soon and you will find out if the skill can be published.",
    "sh-desc-waiting-for-test": "The date is set, we will start testing the devices soon.",
    "sh-precheck": "Preliminary check",
    "sh-testing-text": "This checklist summarizes the testing you should do to prepare your skill for the moderation process.",
    "skill-rejected": "Skill rejected",
    "status-error": "An error occured while loading the status",
    "time-msk": "MSK",
    "time-since": "since",
    "time-till": "till",
    "timings-1-day": "1 workday",
    "timings-2-weeks": "2 weeks",
    "timings-30-min": "30 minutes",
    "timings-sh-meeting": "We are waiting for you in the next two weeks, if during this time we cannot agree on a date for the meeting, then the skill will be rejected",
    "timings-text": "It usually takes",
    "unsaved-alert": "You have unsaved changes, are you sure you want to continue?",
    "validation-availability": "Provider endpoint URL availability check error",
    "validation-code": "Response code",
    "validation-devices": "Error checking the method for updating the list of devices",
    "validation-devices_action": "Error checking the method of changing the state of devices",
    "validation-devices_query": "Error checking method for getting devices status",
    "validation-error_type": "Error type",
    "validation-internal-error": "Internal skill error",
    "validation-method": "Request method",
    "validation-not_found": "URL not found",
    "validation-ssl": "SSL certificate validation error",
    "validation-ssl-hint": "For the skill to work correctly, it is often required to add a chain of SSL certificates to the web server settings and make sure that the certificate is issued to the domain specified in the skill.",
    "validation-status": "Status",
    "validation-timeout": "Response timed out",
    "validation-user_unlink": "Error checking the method of disconnecting accounts",

    "delete": "Delete",
    "delete-text": "Are you sure you want to delete the application?",
    "delete-title": "Delete Application",
    "force-stop-not-empty-comment": "The comment should not be empty",
    "stop": "Stop",
    "stop-text": "Are you sure you want to stop the application?",
    "stop-title": "Stop Application",
    "send-to-moderation": "Send to moderation",
    "change": "Change",
    "changing-data-will-stop-moderation": "Changing the data will stop moderation",
    "if-you-want-to-change-the-data": "If you want to change the data, moderation will be canceled. After making changes, you can send the draft for review again",
    "go-to-draft": "Go to the draft",
    "change-in-copy": "Change in the copy",
    "moderator-comment-placeholder": "Comment for the moderator. \nBe sure to provide the login information for the test account if authorization is required in the application",
    "ready-for-moderation": "Ready for moderation",
    "you-can-not-change-published-version": "You cannot change the published version. Make changes in the draft.",
    "skill-review-request-success": "Skill has been submitted for moderation",
    "skill-review-request-fail": "Failed to submit skill for moderation",
    "skill-review-cancel-success": "Moderation request canceled",
    "skill-deploy-request-success": "Publication request submitted",
    "skill-deploy-request-fail": "Failed to submit publication request",
    "skill-delete-success": "Skill deleted",
    "skill-delete-fail": "Failed to delete skill",
    "skill-stop-success": "Skill stopped",
    "skill-stop-fail": "Failed to stop skill"
} as const;
export const ru = {
    "action-cancel-review": "Вернуть в разработку",
    "action-deploy": "Опубликовать",
    "action-request-review": "На модерацию",
    "action-request-review-again": "Отправить повторно",
    "aired-deploy": "Новая версия диалога отправлена на публикацию.",
    "back": "Назад",
    "button-change-date": "Изменить дату или параметры",
    "cancel": "Отмена",
    "checklist-full": "Полный список требований",
    "checklist-hidden-rules": "активационные имена являются словоформами (склонениями) имени навыка и не состоят из общих фраз\nимя навыка и каждое активационное имя не короче 2 слов (за исключением брендированных) и не длиннее 4 слов",
    "checklist-public-rules": "активационные имена являются словоформами (склонениями) имени навыка и не состоят из общих фраз\nимя навыка и каждое активационное имя не короче 2 слов (за исключением брендированных) и не длиннее 4 слов\nописание содержит информацию о навыке и взаимодействии с ним\nприветственное сообщение содержит краткую инструкцию по взаимодействию с навыком\nв навыке поддержаны команды \"Помощь\" и \"Что ты умеешь?\" по которым он отдает инструкцию по своему использованию\nтекущая функциональность навыка соответствует описанию\nсервер не отвечает ошибкой",
    "checklist-sh-texts-yandex": "Аккаунт без проблем привязывается к Яндексу, и все устройства, подключенные в вашем приложении, появляются в приложении Яндекс\nНа каждом устройстве работают все предусмотренные для него <a target=\"_blank\" href=\"https://yandex.ru/dev/dialogs/alice/doc/smart-home/concepts/capability-types.html/\">умения</a>: любое действие в интерфейсе выполняется быстро и без ошибок.\nКарточки устройств открываются без ошибок, даже если сами устройства не в сети.\nМожно создавать работающие сценарии с одним или несколькими устройствами, заявленными в навыке.",
    "checklist-sh-texts-yango": "Аккаунт без проблем привязывается к Yango, и все устройства, подключенные в вашем приложении, появляются в приложении Yango\nНа каждом устройстве работают все предусмотренные для него <a target=\"_blank\" href=\"https://dialogs.yango.com/docs/smart-home/doc/concepts/capability-types.html/\">умения</a>: любое действие в интерфейсе выполняется быстро и без ошибок.\nКарточки устройств открываются без ошибок, даже если сами устройства не в сети.\nМожно создавать работающие сценарии с одним или несколькими устройствами, заявленными в навыке.",
    "comment": "Комментарий",
    "continue": "Продолжить",
    "date-time": "Дата и время",
    "desc-approved": "Модератор одобрил ваш диалог для публикации. После нажатия на кнопку ниже он станет доступен пользователям.",
    "desc-deploy": "Диалог отправлен на публикацию.",
    "desc-in-dev": "Можно менять его настройки.",
    "desc-in-review": "Диалог будет рассмотрен модератором в течение трёх дней.",
    "eng": "Английский",
    "error": "Произошла ошибка",
    "error-try-again": "Не удалось выполнить операцию. Попробуйте ещё раз.",
    "errors-validation": "Ошибки валидации:",
    "invalid-settings": "Настройки заполнены некорректно.\nЗаполните обязательные настройки навыка и связку аккаунтов.",
    "lang": "Язык",
    "make-sure": "Убедитесь, что",
    "meeting-approved": "Согласовано",
    "meeting-approved-on": "Согласовано на",
    "meeting-choose-lang": "На каком языке вам будет комфортно общаться?",
    "meeting-devices-sent-yandex": "Все устройства, заявленные в описании, переданы в офис Яндекса, и тестирование по скайпу не требуется.",
    "meeting-devices-sent-yango": "Все устройства, заявленные в описании, переданы в офис Yango, и тестирование по скайпу не требуется.",
    "meeting-not-agreed": "Не согласовано. Измените дату",
    "meeting-office": "В офисе",
    "meeting-prepare-yandex": "Подготовьте тестовый стенд со всеми типами устройств, заявленными в описании навыка. Устройства должны быть реальными, и представители Яндекса должны иметь возможность управлять ими через приложение Яндекс",
    "meeting-prepare-yango": "Подготовьте тестовый стенд со всеми типами устройств, заявленными в описании навыка. Устройства должны быть реальными, и представители Yango должны иметь возможность управлять ими через приложение Yango",
    "meeting-provider-login": "Логин из приложения провайдера",
    "meeting-provider-password": "Пароль из приложения провайдера",
    "meeting-zoom": "Zoom",
    "meeting-zoom-link": "Ссылка на Zoom",
    "meeting-skype": "Skype",
    "meeting-skype-login": "Логин в Skype",
    "meeting-wait-approval": "Ожидаем подтверждение",
    "others": "Прочее",
    "published": "опубликовано",
    "rus": "Русский",
    "save": "Сохранить",
    "sh-desc-approved": "Теперь ваш навык можно публиковать. Сделайте это, и он будет доступен пользователям.",
    "sh-desc-devices-testing": "Проверяем, хорошо ли работает ваш навык.",
    "sh-desc-in-dev": "Пока это черновик и его настройки можно менять.",
    "sh-desc-in-review": "Сверяем описание навыка с формальными требованиями.",
    "sh-desc-meeting": "Написали вам письмо и ждём, пока вы выберите дату тестирования устройств.",
    "sh-desc-testing-complete": "Скоро пришлём отчёт и вы узнаете, можно ли публиковать навык.",
    "sh-desc-waiting-for-test": "Дата назначена, скоро начнём тестировать устройства.",
    "sh-precheck": "Предварительная проверка",
    "sh-testing-text": "Перед тем как отправлять навык на модерацию, проверьте, всё ли с ним в порядке.",
    "skill-rejected": "Навык отклонен",
    "status-error": "Произошла ошибка при загрузке статуса",
    "time-msk": "МСК",
    "time-since": "с",
    "time-till": "до",
    "timings-1-day": "1 рабочий день",
    "timings-2-weeks": "2 недели",
    "timings-30-min": "30 минут",
    "timings-sh-meeting": "Мы ждем вас в ближайшие две недели, если за это время нам не удастся согласовать дату встречи, то навык будет отклонён",
    "timings-text": "Обычно это занимает",
    "unsaved-alert": "У вас есть несохраненные изменения, вы действительно хотите продолжить?",
    "validation-availability": "Ошибка проверки доступности Endpoint URL провайдера",
    "validation-code": "Код ответа",
    "validation-devices": "Ошибка проверки метода обновления списка устройств",
    "validation-devices_action": "Ошибка проверки метода изменения состояния устройств",
    "validation-devices_query": "Ошибка проверки метода получения состояния устройств",
    "validation-error_type": "Тип ошибки",
    "validation-internal-error": "Внутренняя ошибка навыка",
    "validation-method": "Метод запроса",
    "validation-not_found": "URL не найден",
    "validation-ssl": "Ошибка валидации SSL сертификата",
    "validation-ssl-hint": "Для коррекной работы навыка часто требуется добавить цепочку SSL-сертификатов в настройки веб-сервера и убедиться, что сертификат выписан на указанный в навыке домен.",
    "validation-status": "Статус",
    "validation-timeout": "Превышено время ожидания ответа",
    "validation-user_unlink": "Ошибка проверки метода разъединения аккаунтов",

    "delete": "Удалить",
    "delete-text": "Вы уверены, что хотите удалить приложение?",
    "delete-title": "Удалить приложение",
    "force-stop-not-empty-comment": "Комментарий не должен быть пустым",
    "stop": "Остановить",
    "stop-text": "Вы уверены, что хотите остановить приложение?",
    "stop-title": "Остановить приложение",
    "send-to-moderation": "Отправить на модерацию",
    "change": "Изменить",
    "changing-data-will-stop-moderation": "Изменение данных остановит модерацию",
    "if-you-want-to-change-the-data": "Если вы хотите изменить данные, модерация отменится. После внесения изменений можно будет снова отправить черновик на проверку",
    "go-to-draft": "Перейти в черновик",
    "change-in-copy": "Изменяйте в копии",
    "moderator-comment-placeholder": "Комментарий для модератора. \nОбязательно укажите данные для входа в тестовый аккаунт, если в приложении требуется авторизация",
    "ready-for-moderation": "Готово к модерации",
    "you-can-not-change-published-version": "Нельзя изменять опубликованную версию. Вносите изменения в черновике.",
    "skill-review-request-success": "Навык отправлен на модерацию",
    "skill-review-request-fail": "Не удалось отправить навык на модерацию",
    "skill-review-cancel-success": "Запрос на модерацию отменен",
    "skill-deploy-request-success": "Отправлен запрос на публикацию",
    "skill-deploy-request-fail": "Не удалось отправить запрос на публикацию",
    "skill-delete-success": "Навык удален",
    "skill-delete-fail": "Не удалось удалить навык",
    "skill-stop-success": "Навык остановлен",
    "skill-stop-fail": "Не удалось остановить навык",
} as const;
